module.exports = __webpack_public_path__ + "img/name-1.716e106b.png";